import request from '../request';
import analytics from '../analytics';
import * as cartStorage from './cartStorage';

const form = cartStorage.load();

function totalWithoutVouchersLocal(state) {
  let total = 0;
  let sc = parseInt(state.shippingCosts, 10);
  if (Number.isNaN(sc)) {
    sc = 0;
  }
  state.form.forEach((item) => {
    if (item.type !== 'voucherCode') {
      total += parseInt(item.totalPrice, 10);
    }
  });
  total += sc;
  if (total < 0) {
    total = 0;
  }
  return total;
}

function prepareCart(cart) {
  const newCart = [];
  cart.forEach((item) => {
    const newItem = {};
    newItem.type = item.type;
    newItem.id = item.id;
    if (item.type === 'guidedTour') {
      newItem.datetime = `${item.date} ${item.time}`;
      if (!newItem.single_ticketing) {
        newItem.count = 1;
      }
    }
    if (item.type === 'merchandise') {
      newItem.count = item.count;
    }
    if (item.type === 'ticket') {
      newItem.count = item.totalCount;
      newItem.datetime = item.datetime;
      newItem.subtickets = item.subtickets;
    }
    if (item.type === 'dayTicket') {
      newItem.dayTickets.forEach((dayTicket) => {
        newItem.datetime = item.datetime;
        newCart.push({
          type: 'dayticket',
          count: dayTicket.count,
          id: dayTicket.id,
        });
      });
    }
    if (item.type !== 'dayTicket') {
      newCart.push(newItem);
    }
  });
  return newCart;
}

function recomputeBundleTotal(item) {
  if (typeof item.subtickets !== 'undefined') {
    let totalSubTicketPrice = 0;
    item.subtickets.forEach((st) => {
      let stPrice = st.price;
      if (typeof st.price === 'undefined') {
        stPrice = 0;
      }
      totalSubTicketPrice += stPrice * st.count;
    });
    if (typeof item.originalTotalPrice === 'undefined') {
      item.originalTotalPrice = item.totalPrice;
    }
    const newTotalPrice = Math.ceil(item.price * item.totalCount + totalSubTicketPrice);
    if (newTotalPrice < item.totalPrice) {
      item.totalPrice = newTotalPrice;
    }
  }
  if (typeof item.tours !== 'undefined') {
    let newTotalPrice = 0;
    let totalTourPrice = 0;
    item.tours.forEach((t) => {
      totalTourPrice += t.price * t.count;
    });
    if (typeof item.originalTotalPrice === 'undefined') {
      item.originalTotalPrice = item.totalPrice;
    }
    newTotalPrice += Math.ceil(totalTourPrice);

    if (typeof item.tickets !== 'undefined') {
      let totalTicketPrice = 0;
      item.tickets.forEach((st) => {
        totalTicketPrice += st.price * st.count;
        if (st.subtickets) {
          st.subtickets.forEach((sub) => {
            totalTicketPrice += sub.price * sub.count;
          });
        }
      });
      if (typeof item.originalTotalPrice === 'undefined') {
        item.originalTotalPrice = item.totalPrice;
      }
      newTotalPrice += totalTicketPrice;
      if (newTotalPrice < item.totalPrice) {
        item.totalPrice = newTotalPrice;
      }
    }
  }
}

function discountedUnit(original, units, amount, round) {
  if (units === '0') {
    const p = round(original * (1 - parseInt(amount, 10) / 100));
    return p < 0 ? 0 : p;
  }
  if (units === '1') {
    const p = round(original - parseInt(amount, 10));
    return p < 0 ? 0 : p;
  }
  return original;
}

function applyMerchLineDiscount(item, count, units, amount, discountId, keyword) {
  item.count = count;
  item.originalTotalPrice = item.price * count;
  item.discountId = discountId;
  item.keyword = keyword;
  item.totalPrice = discountedUnit(item.price, units, amount, Math.ceil) * count;
}

function isActualPriceChange(priceData) {
  return (
    typeof priceData !== 'undefined' &&
    priceData !== null &&
    typeof priceData.new_price !== 'undefined' &&
    parseInt(priceData.new_price, 10) !== parseInt(priceData.origin_price, 10)
  );
}

function applyEntryDiscount(entry, units, amount, discountId, keyword, round) {
  if (typeof entry.originalPrice === 'undefined') {
    entry.originalPrice = entry.price;
  }
  entry.discountId = discountId;
  entry.keyword = keyword;
  entry.price = discountedUnit(entry.originalPrice, units, amount, round);
}

export default {
  namespaced: true,
  state: {
    form,
    requestInvoice: true, // for dms is set to false on load
    error: '',
    cartId: null,
    shippingCosts: null,
    shippingError: '',
    shippingCostsError: '',
    externalDocumentNumber: '',
    promoCodeDoesNotApplyToCurrentItems: null,
  },
  mutations: {
    add(state, item) {
      let shouldAdd = true;
      if (item.type === 'voucherCode') {
        const existingItem = state.form.find((i) => item.barcode === i.barcode);
        if (typeof existingItem !== 'undefined') {
          shouldAdd = false;
        }
      }
      if (item.type === 'promoCode') {
        const existingItem = state.form.find((item) => {
          return item.type === 'promoCode';
          //|| typeof item.discountId !== 'undefined';
        });
        if (typeof existingItem !== 'undefined') {
          shouldAdd = false;
        }
      }
      if (shouldAdd) {
        const newCart = state.form;
        newCart.push(item);
        cartStorage.save(state.form);
      }
    },
    applyPromoCode(state, { cartItemIndex, discountId, units, amount, keyword }) {
      const promoCodeItem = state.form.find((item) => {
        return item.type === 'promoCode';
      });
      if (typeof promoCodeItem === 'undefined') {
        // Skip items that already have an instant discount
        if (
          state.form[cartItemIndex].oldPrice !== null &&
          typeof state.form[cartItemIndex].oldPrice !== 'undefined'
        ) {
          return;
        }
        if (typeof state.form[cartItemIndex].subtickets !== 'undefined') {
          if (
            typeof state.form[cartItemIndex].subtickets.find((st) => st.discountId) !== 'undefined'
          ) {
            return;
          }
        }
        if (typeof state.form[cartItemIndex].tours !== 'undefined') {
          if (typeof state.form[cartItemIndex].tours.find((t) => t.discountId) !== 'undefined') {
            return;
          }
        }

        if (
          typeof state.form[cartItemIndex].discountId === 'undefined' ||
          state.form[cartItemIndex].discountId === null
        ) {
          if (typeof state.form[cartItemIndex].originalTotalPrice === 'undefined') {
            state.form[cartItemIndex].originalTotalPrice = state.form[cartItemIndex].totalPrice;
          }
          state.form[cartItemIndex].discountId = discountId;
          state.form[cartItemIndex].keyword = keyword;
          state.promoCodeDoesNotApplyToCurrentItems = false;
          if (units === '0') {
            state.form[cartItemIndex].totalPrice = Math.ceil(
              state.form[cartItemIndex].originalTotalPrice * (1 - parseInt(amount, 10) / 100)
            );
          } else if (units === '1') {
            state.form[cartItemIndex].totalPrice =
              state.form[cartItemIndex].originalTotalPrice - parseInt(amount, 10);
            if (state.form[cartItemIndex].totalPrice < 0) {
              state.form[cartItemIndex].totalPrice = 0;
            }
          }
        }
      }
      cartStorage.save(state.form);
    },
    applyPromoCodeToTicket(
      state,
      { cartItemIndex, ticketIndex, discountId, units, amount, keyword }
    ) {
      const promoCodeItem = state.form.find((item) => {
        return item.type === 'promoCode';
      });
      if (typeof promoCodeItem === 'undefined') {
        if (typeof state.form[cartItemIndex].tickets[ticketIndex].discountId === 'undefined') {
          if (typeof state.form[cartItemIndex].tickets[ticketIndex].originalPrice === 'undefined') {
            state.form[cartItemIndex].tickets[ticketIndex].originalPrice =
              state.form[cartItemIndex].tickets[ticketIndex].price;
          }
          state.form[cartItemIndex].tickets[ticketIndex].discountId = discountId;
          state.form[cartItemIndex].tickets[ticketIndex].keyword = keyword;
          state.promoCodeDoesNotApplyToCurrentItems = false;
          if (units === '0') {
            state.form[cartItemIndex].tickets[ticketIndex].price =
              state.form[cartItemIndex].tickets[ticketIndex].originalPrice *
              (1 - parseInt(amount, 10) / 100);
          } else if (units === '1') {
            state.form[cartItemIndex].tickets[ticketIndex].price =
              state.form[cartItemIndex].tickets[ticketIndex].originalPrice - parseInt(amount, 10);
          }
        }
      }
    },
    setCartItemKeyword(state, { cartItemIndex, keyword }) {
      if (!state.form[cartItemIndex].keyword) {
        state.form[cartItemIndex].keyword = keyword;
        cartStorage.save(state.form);
      }
    },
    applyPromoCodeToTour(state, { cartItemIndex, tourIndex, discountId, units, amount, keyword }) {
      const promoCodeItem = state.form.find((item) => {
        return item.type === 'promoCode';
      });
      if (typeof promoCodeItem === 'undefined') {
        if (typeof state.form[cartItemIndex].tours[tourIndex].discountId === 'undefined') {
          if (typeof state.form[cartItemIndex].tours[tourIndex].originalPrice === 'undefined') {
            state.form[cartItemIndex].tours[tourIndex].originalPrice =
              state.form[cartItemIndex].tours[tourIndex].price;
          }
          state.form[cartItemIndex].tours[tourIndex].discountId = discountId;
          state.form[cartItemIndex].tours[tourIndex].keyword = keyword;
          state.promoCodeDoesNotApplyToCurrentItems = false;
          if (units === '0') {
            state.form[cartItemIndex].tours[tourIndex].price = Math.ceil(
              state.form[cartItemIndex].tours[tourIndex].originalPrice *
                (1 - parseInt(amount, 10) / 100)
            );
          } else if (units === '1') {
            state.form[cartItemIndex].tours[tourIndex].price =
              state.form[cartItemIndex].tours[tourIndex].originalPrice - parseInt(amount, 10);
            if (state.form[cartItemIndex].tours[tourIndex].price < 0) {
              state.form[cartItemIndex].tours[tourIndex].price = 0;
            }
          }
        }
      }
      cartStorage.save(state.form);
    },
    applyPromoCodeToSubticket(
      state,
      { cartItemIndex, subticketIndex, discountId, units, amount, keyword }
    ) {
      const promoCodeItem = state.form.find((item) => {
        return item.type === 'promoCode';
      });
      if (typeof promoCodeItem === 'undefined') {
        if (
          typeof state.form[cartItemIndex].subtickets[subticketIndex].discountId === 'undefined'
        ) {
          if (
            typeof state.form[cartItemIndex].subtickets[subticketIndex].originalPrice ===
            'undefined'
          ) {
            state.form[cartItemIndex].subtickets[subticketIndex].originalPrice =
              state.form[cartItemIndex].subtickets[subticketIndex].price;
          }
          state.form[cartItemIndex].subtickets[subticketIndex].discountId = discountId;
          state.form[cartItemIndex].subtickets[subticketIndex].keyword = keyword;
          state.promoCodeDoesNotApplyToCurrentItems = false;
          if (units === '0') {
            state.form[cartItemIndex].subtickets[subticketIndex].price = Math.round(
              state.form[cartItemIndex].subtickets[subticketIndex].originalPrice *
                (1 - parseInt(amount, 10) / 100)
            );
          } else if (units === '1') {
            state.form[cartItemIndex].subtickets[subticketIndex].price = Math.round(
              state.form[cartItemIndex].subtickets[subticketIndex].originalPrice -
                parseInt(amount, 10)
            );
          }
        }
      }
      cartStorage.save(state.form);
    },
    recalculateTicketTotal(state, { cartItemIndex }) {
      recomputeBundleTotal(state.form[cartItemIndex]);
      cartStorage.save(state.form);
    },
    calculateVoucherValues(state) {
      const total = totalWithoutVouchersLocal(state);
      let currentTotal = total;
      let touched = false;
      state.form.forEach((item, i) => {
        if (item.type === 'voucherCode') {
          const discount = item.totalPrice * -1;
          let remainingAmount = discount;
          let newTotal = currentTotal;
          if (currentTotal !== 0) {
            newTotal = currentTotal - discount;
            if (newTotal < 0) {
              newTotal = 0;
            }
            remainingAmount = discount - (currentTotal - newTotal);
          }
          state.form[i].remaining = remainingAmount;
          state.form[i].discount = (discount - remainingAmount) * -1;
          currentTotal = newTotal;
          touched = true;
        }
      });
      if (touched) {
        cartStorage.save(state.form);
      }
    },
    applyCustomerDiscountFromAPI(state, { data, jwt }) {
      state.form.forEach((item, i) => {
        if (item.type === 'voucherCode' || item.type === 'promoCode') return;
        const priceData = data[item.id];
        if (isActualPriceChange(priceData)) {
          if (typeof item.originalTotalPrice !== 'undefined') {
            state.form[i].totalPrice = item.originalTotalPrice;
            delete state.form[i].originalTotalPrice;
            delete state.form[i].keyword;
          }
          delete state.form[i].originalPrice;
          if (jwt && typeof state.form[i].customerDiscountOriginalPrice === 'undefined' && priceData.object_kind === 'customer') {
            const originPrice = parseInt(priceData.origin_price, 10);
            const newPrice = parseInt(priceData.new_price, 10);
            if (originPrice !== newPrice) {
              if (item.type === 'ticket') {
                state.form[i].customerDiscountOriginalPrice = originPrice * (item.totalCount || 1);
              } else {
                state.form[i].customerDiscountOriginalPrice = originPrice * (item.count || 1);
              }
            }
          }
          state.form[i].discountId = priceData.id;
          state.form[i].oldPrice = parseInt(priceData.origin_price, 10);
          if (item.type === 'ticket') {
            state.form[i].price = priceData.new_price;
            state.form[i].totalPrice = priceData.new_price * item.totalCount;
          } else {
            state.form[i].totalPrice = priceData.new_price * (item.count || 1);
            state.form[i].price = priceData.new_price;
          }
        }
        if (item.subtickets) {
          item.subtickets.forEach((st, si) => {
            const stData = data[st.id];
            if (isActualPriceChange(stData)) {
              state.form[i].subtickets[si].originalPrice = parseInt(stData.origin_price, 10);
              state.form[i].subtickets[si].discountId = stData.id;
              state.form[i].subtickets[si].price = stData.new_price;
            }
          });
          // Recalculate totalPrice from cover price + subticket prices
          let subTotal = 0;
          state.form[i].subtickets.forEach((st) => {
            subTotal += parseInt(st.price, 10) * st.count;
          });
          state.form[i].totalPrice = parseInt(state.form[i].price, 10) * item.totalCount + subTotal;
        }
        if (item.type === 'guidedTour' && item.tours) {
          item.tours.forEach((t, ti) => {
            const tData = data[t.id];
            if (isActualPriceChange(tData)) {
              state.form[i].tours[ti].originalPrice = parseInt(tData.origin_price, 10);
              state.form[i].tours[ti].discountId = tData.id;
              state.form[i].tours[ti].price = tData.new_price;
            }
          });
          if (item.tickets) {
            item.tickets.forEach((t, ti) => {
              const tData = data[t.id];
              if (isActualPriceChange(tData)) {
                state.form[i].tickets[ti].originalPrice = parseInt(tData.origin_price, 10);
                state.form[i].tickets[ti].discountId = tData.id;
                state.form[i].tickets[ti].price = tData.new_price;
              }
              if (Array.isArray(t.subtickets)) {
                t.subtickets.forEach((st, si) => {
                  const stData = data[st.id];
                  if (isActualPriceChange(stData)) {
                    state.form[i].tickets[ti].subtickets[si].originalPrice = parseInt(
                      stData.origin_price,
                      10
                    );
                    state.form[i].tickets[ti].subtickets[si].discountId = stData.id;
                    state.form[i].tickets[ti].subtickets[si].price = stData.new_price;
                  }
                });
              }
            });
          }
          // Recalculate totalPrice from tours + tickets + subtickets
          let tourTotal = 0;
          state.form[i].tours.forEach((t) => {
            tourTotal += parseInt(t.price, 10) * t.count;
          });
          if (item.tickets) {
            state.form[i].tickets.forEach((t) => {
              tourTotal += parseInt(t.price, 10) * t.count;
              if (Array.isArray(t.subtickets)) {
                t.subtickets.forEach((st) => {
                  tourTotal += parseInt(st.price, 10) * st.count;
                });
              }
            });
          }
          state.form[i].totalPrice = tourTotal;
        }
      });
      cartStorage.save(state.form);
    },
    clearCustomerDiscount(state) {
      state.form.forEach((item, i) => {
        if (item.type === 'merchandise' || item.type === 'annualPass') {
          delete state.form[i].customerDiscountOriginalPrice;
          delete state.form[i].discountId;
          if (typeof item.oldPrice !== 'undefined' && item.oldPrice !== null) {
            state.form[i].price = item.oldPrice;
            state.form[i].totalPrice = parseInt(item.oldPrice, 10) * (item.count || 1);
            state.form[i].oldPrice = null;
          }
        }
        if (item.type === 'ticket') {
          delete state.form[i].customerDiscountOriginalPrice;
          delete state.form[i].discountId;
          if (typeof item.oldPrice !== 'undefined' && item.oldPrice !== null) {
            state.form[i].price = item.oldPrice;
            state.form[i].oldPrice = null;
          }
          if (typeof item.subtickets !== 'undefined') {
            item.subtickets.forEach((st, si) => {
              if (typeof st.originalPrice !== 'undefined') {
                state.form[i].subtickets[si].price = st.originalPrice;
                delete state.form[i].subtickets[si].originalPrice;
                delete state.form[i].subtickets[si].discountId;
              }
            });
          }
          if (typeof item.tours !== 'undefined') {
            item.tours.forEach((t, ti) => {
              if (typeof t.originalPrice !== 'undefined') {
                state.form[i].tours[ti].price = t.originalPrice;
                delete state.form[i].tours[ti].originalPrice;
                delete state.form[i].tours[ti].discountId;
              }
            });
          }
          // Recalculate totalPrice from restored prices
          let ticketTotal = parseInt(state.form[i].price, 10) * (item.totalCount || 1);
          if (item.subtickets) {
            item.subtickets.forEach((st) => {
              ticketTotal += parseInt(st.price, 10) * st.count;
            });
          }
          state.form[i].totalPrice = ticketTotal;
        }
        if (item.type === 'guidedTour') {
          delete state.form[i].customerDiscountOriginalPrice;
          delete state.form[i].discountId;
          if (typeof item.oldPrice !== 'undefined' && item.oldPrice !== null) {
            state.form[i].price = item.oldPrice;
            state.form[i].oldPrice = null;
          }
          if (typeof item.tours !== 'undefined') {
            item.tours.forEach((t, ti) => {
              if (typeof t.originalPrice !== 'undefined') {
                state.form[i].tours[ti].price = t.originalPrice;
                delete state.form[i].tours[ti].originalPrice;
                delete state.form[i].tours[ti].discountId;
              }
            });
          }
          if (typeof item.tickets !== 'undefined') {
            item.tickets.forEach((t, ti) => {
              if (typeof t.originalPrice !== 'undefined') {
                state.form[i].tickets[ti].price = t.originalPrice;
                delete state.form[i].tickets[ti].originalPrice;
                delete state.form[i].tickets[ti].discountId;
              }
            });
          }
          // Recalculate totalPrice from restored prices
          let tourTotal = 0;
          if (item.tours) {
            item.tours.forEach((t) => {
              tourTotal += parseInt(t.price, 10) * t.count;
            });
          }
          if (item.tickets) {
            item.tickets.forEach((t) => {
              tourTotal += parseInt(t.price, 10) * t.count;
            });
          }
          state.form[i].totalPrice = tourTotal;
        }
        if (item.type === 'voucher') {
          delete state.form[i].customerDiscountOriginalPrice;
          delete state.form[i].discountId;
          if (typeof item.oldPrice !== 'undefined' && item.oldPrice !== null) {
            state.form[i].price = item.oldPrice;
            state.form[i].totalPrice = parseInt(item.oldPrice, 10) * (item.count || 1);
            state.form[i].oldPrice = null;
          }
        }
      });
      cartStorage.save(state.form);
    },
    clearPromoCodes(state) {
      const newCart = [];
      state.form.forEach((item) => {
        if (item.type !== 'promoCode') {
          newCart.push(item);
        }
      });
      state.form = newCart;
      cartStorage.save(state.form);
    },
    remove(state, index) {
      state.form.splice(index, 1);
      cartStorage.save(state.form);
    },
    clear(state) {
      state.form = [];
      state.cartId = null;
    },
    hydrate(state, form) {
      state.form = Array.isArray(form) ? form : [];
    },
    clearShippingError(state) {
      state.shippingCostsError = '';
    },
    removePromocode(state) {
      state.form.forEach((item, i) => {
        if (item.type === 'promoCode') {
          state.form.splice(i, 1);
        }
        if (item.keyword) {
          if (item.discountId !== null) {
            item.discountId = null;
          }
          if (typeof item.originalPrice !== 'undefined') {
            item.price = item.originalPrice;
            delete item.originalPrice;
          }
          if (typeof item.originalTotalPrice !== 'undefined') {
            item.totalPrice = item.originalTotalPrice;
            delete item.originalTotalPrice;
          }
          delete item.keyword;
        }
        if (typeof item.subtickets !== 'undefined') {
          item.subtickets.forEach((st) => {
            if (st.keyword) {
              delete st.discountId;
              delete st.keyword;
              if (typeof st.originalPrice !== 'undefined') {
                st.price = st.originalPrice;
                delete st.originalPrice;
              }
            }
          });
        }
        if (typeof item.tickets !== 'undefined') {
          item.tickets.forEach((st) => {
            if (st.keyword) {
              delete st.discountId;
              delete st.keyword;
              if (typeof st.originalPrice !== 'undefined') {
                st.price = st.originalPrice;
                delete st.originalPrice;
              }
            }
          });
        }
        if (typeof item.tours !== 'undefined') {
          item.tours.forEach((t) => {
            if (t.keyword) {
              delete t.discountId;
              delete t.keyword;
              if (typeof t.originalPrice !== 'undefined') {
                t.price = t.originalPrice;
                delete t.originalPrice;
              }
            }
          });
        }
      });
      cartStorage.save(state.form);
    },
    setError(state, error) {
      let e = error;
      if (typeof error === 'object') {
        const keys = Object.keys(error);
        e = error[keys[0]];
      }
      state.error = e;
    },
    setCartId(state, cartId) {
      state.cartId = cartId;
    },
    setDocumentNumber(state, v) {
      state.externalDocumentNumber = v;
    },
    setShippingCost(state, shippingCosts) {
      Object.assign(state, { shippingCosts });
    },
    setShippingCostError(state, error) {
      state.shippingCostsError = error.code;
    },
    setRequestInvoice(state, v) {
      Object.assign(state, { requestInvoice: v });
    },
    setPromoCodeDoesNotApplyToCurrentItems(state, v) {
      state.promoCodeDoesNotApplyToCurrentItems = v;
    },
    applyCountLimitedPromoCode(state, { items, itemsCount, discount }) {
      // Never stack on a cart-level promoCode line
      if (typeof state.form.find((item) => item.type === 'promoCode') !== 'undefined') {
        return;
      }

      const { id: discountId, units, amount, keyword } = discount;
      const discountable = Array.isArray(items) ? items.map((i) => i.toString()) : [];
      const budget = {};
      Object.keys(itemsCount || {}).forEach((k) => {
        budget[k] = parseInt(itemsCount[k], 10);
      });
      const budgetFor = (id) => {
        const key = id.toString();
        if (key in budget) return budget[key];
        if (discountable.includes(key)) return Infinity;
        return 0;
      };
      const consume = (id, n) => {
        const key = id.toString();
        if (key in budget) budget[key] -= n;
      };

      let applied = false;

      // Splits a list of priced entries ({ id, count, price }) into discounted +
      // full-price siblings according to the remaining per-price budget.
      const processEntries = (list, round) => {
        const out = [];
        let touched = false;
        list.forEach((entry) => {
          if (typeof entry.discountId !== 'undefined' && entry.discountId !== null) {
            out.push(entry);
            return;
          }
          const qty = entry.count;
          const avail = budgetFor(entry.id);
          if (avail <= 0 || qty <= 0 || !discountable.includes(entry.id.toString())) {
            out.push(entry);
            return;
          }
          if (avail >= qty) {
            applyEntryDiscount(entry, units, amount, discountId, keyword, round);
            consume(entry.id, qty);
            touched = true;
            applied = true;
            out.push(entry);
            return;
          }
          const full = { ...entry };
          full.count = qty - avail;
          full.splitFromPromo = true;
          if (Array.isArray(entry.subtickets)) {
            full.subtickets = entry.subtickets.map((s) => ({ ...s }));
          }
          delete full.discountId;
          delete full.keyword;
          delete full.originalPrice;
          entry.count = avail;
          applyEntryDiscount(entry, units, amount, discountId, keyword, round);
          consume(entry.id, avail);
          touched = true;
          applied = true;
          out.push(entry);
          out.push(full);
        });
        return { out, touched };
      };

      const newForm = [];
      state.form.forEach((item) => {
        if (item.type === 'promoCode' || item.type === 'voucherCode') {
          newForm.push(item);
          return;
        }

        if (item.type === 'merchandise' || item.type === 'annualPass' || item.type === 'voucher') {
          const alreadyDiscounted =
            (item.oldPrice !== null && typeof item.oldPrice !== 'undefined') ||
            (typeof item.discountId !== 'undefined' && item.discountId !== null);
          const qty = item.count;
          const avail = budgetFor(item.id);
          if (
            alreadyDiscounted ||
            avail <= 0 ||
            qty <= 0 ||
            !discountable.includes(item.id.toString())
          ) {
            newForm.push(item);
            return;
          }
          if (avail >= qty) {
            applyMerchLineDiscount(item, qty, units, amount, discountId, keyword);
            consume(item.id, qty);
            applied = true;
            newForm.push(item);
            return;
          }
          const fullCount = qty - avail;
          const allOwners = Array.isArray(item.owners) ? item.owners : null;
          const fullItem = { ...item };
          fullItem.count = fullCount;
          fullItem.totalPrice = item.price * fullCount;
          fullItem.splitFromPromo = true;
          delete fullItem.discountId;
          delete fullItem.keyword;
          delete fullItem.originalTotalPrice;
          if (allOwners) {
            item.owners = allOwners.slice(0, avail);
            fullItem.owners = allOwners.slice(avail);
          }
          applyMerchLineDiscount(item, avail, units, amount, discountId, keyword);
          consume(item.id, avail);
          applied = true;
          newForm.push(item);
          newForm.push(fullItem);
          return;
        }

        if (item.type === 'ticket') {
          let touched = false;
          let fullLine = null;
          const alreadyDiscounted =
            (item.oldPrice !== null && typeof item.oldPrice !== 'undefined') ||
            (typeof item.discountId !== 'undefined' && item.discountId !== null);
          const qty = item.totalCount;
          const avail = budgetFor(item.id);
          if (
            !alreadyDiscounted &&
            discountable.includes(item.id.toString()) &&
            avail > 0 &&
            qty > 0
          ) {
            let subTotal = 0;
            if (Array.isArray(item.subtickets)) {
              item.subtickets.forEach((st) => {
                subTotal += (st.price || 0) * st.count;
              });
            }
            if (avail < qty) {
              fullLine = { ...item };
              fullLine.totalCount = qty - avail;
              if (Array.isArray(item.subtickets)) {
                fullLine.subtickets = [];
              }
              if (Array.isArray(item.seats)) {
                fullLine.seats = item.seats.slice(avail);
                item.seats = item.seats.slice(0, avail);
              }
              fullLine.totalPrice = item.price * fullLine.totalCount;
              fullLine.originalTotalPrice = fullLine.totalPrice;
              fullLine.splitFromPromo = true;
              delete fullLine.discountId;
              delete fullLine.keyword;
              delete fullLine.originalPrice;
              item.totalCount = avail;
            }
            if (typeof item.originalPrice === 'undefined') {
              item.originalPrice = item.price;
            }
            item.discountId = discountId;
            item.keyword = keyword;
            item.price = discountedUnit(item.originalPrice, units, amount, Math.ceil);
            item.originalTotalPrice = item.originalPrice * item.totalCount + subTotal;
            item.totalPrice = item.price * item.totalCount + subTotal;
            consume(item.id, item.totalCount);
            touched = true;
            applied = true;
          }
          if (Array.isArray(item.subtickets)) {
            const res = processEntries(item.subtickets, Math.round);
            item.subtickets = res.out;
            touched = touched || res.touched;
          }
          if (touched) {
            if (!item.keyword) item.keyword = keyword;
            recomputeBundleTotal(item);
          }
          newForm.push(item);
          if (fullLine !== null) {
            newForm.push(fullLine);
          }
          return;
        }

        if (item.type === 'guidedTour') {
          let touched = false;
          if (Array.isArray(item.tours)) {
            const res = processEntries(item.tours, Math.ceil);
            item.tours = res.out;
            touched = touched || res.touched;
          }
          if (Array.isArray(item.tickets)) {
            const res = processEntries(item.tickets, (x) => x);
            item.tickets = res.out;
            touched = touched || res.touched;
            item.tickets.forEach((tk) => {
              if (Array.isArray(tk.subtickets)) {
                const resSub = processEntries(tk.subtickets, Math.round);
                tk.subtickets = resSub.out;
                touched = touched || resSub.touched;
              }
            });
          }
          if (touched) {
            if (!item.keyword) item.keyword = keyword;
            recomputeBundleTotal(item);
          }
          newForm.push(item);
          return;
        }

        newForm.push(item);
      });

      state.form = newForm;
      if (applied) {
        state.promoCodeDoesNotApplyToCurrentItems = false;
      }
      cartStorage.save(state.form);
    },
  },
  actions: {
    add(context, item) {
      context.commit('add', item);
      if (item.type !== 'promoCode') {
        context.dispatch('recalculatePromoCodes');
      }
    },
    applyPromoCode(context, payload) {
      context.commit('applyPromoCode', payload);
    },
    applyCountLimitedPromoCode(context, payload) {
      context.commit('applyCountLimitedPromoCode', payload);
    },
    applyPromoCodeToTicket(context, payload) {
      context.commit('applyPromoCodeToTicket', payload);
    },
    applyPromoCodeToSubticket(context, payload) {
      context.commit('applyPromoCodeToSubticket', payload);
    },
    applyPromoCodeToTour(context, payload) {
      context.commit('applyPromoCodeToTour', payload);
    },
    setCartItemKeyword(context, payload) {
      context.commit('setCartItemKeyword', payload);
    },
    fetchPrices(context, { priceIds, jwt }) {
      return new Promise((resolve, reject) => {
        const { app } = context.rootState;
        const priceParams = priceIds.map((id) => `price[]=${id}`).join('&');
        let url = `${app.API_URL}${context.rootState.language}/${app.endpoints.FETCH_PRICES}?${priceParams}`;
        if (jwt) {
          url += `&_=${jwt}`;
        }
        request.make({ url, type: 'GET' }, (err, res) => {
          if (err) {
            reject(err);
          } else {
            resolve(res.body.data);
          }
        });
      });
    },
    applyCustomerDiscountFromAPI(context, jwt) {
      const priceIds = [];
      context.state.form.forEach((item) => {
        if (item.type === 'voucherCode' || item.type === 'promoCode') return;
        if (item.type !== 'guidedTour') {
          priceIds.push(item.id);
        }
        if (item.subtickets) {
          item.subtickets.forEach((st) => priceIds.push(st.id));
        }
        if (item.tours) {
          item.tours.forEach((t) => priceIds.push(t.id));
        }
        if (item.tickets) {
          item.tickets.forEach((t) => {
            priceIds.push(t.id);
            if (Array.isArray(t.subtickets)) {
              t.subtickets.forEach((st) => priceIds.push(st.id));
            }
          });
        }
      });
      if (priceIds.length === 0) return Promise.resolve();
      return context
        .dispatch('fetchPrices', { priceIds, jwt })
        .then((data) => {
          context.commit('applyCustomerDiscountFromAPI', { data, jwt });
        })
        .catch(() => {
          // If fetchPrices fails, keep current prices unchanged
        });
    },
    clearCustomerDiscount(context) {
      context.commit('clearCustomerDiscount');
      return context.dispatch('applyCustomerDiscountFromAPI', null);
    },
    recalculateTicketTotal(context, { cartItemIndex }) {
      context.commit('recalculateTicketTotal', { cartItemIndex });
    },
    clear(context) {
      context.commit('clear');
      cartStorage.clear();
    },
    revalidateExpiry(context) {
      if (cartStorage.pruneIfExpired()) {
        context.commit('hydrate', []);
      }
    },
    clearShippingError(context) {
      context.commit('clearShippingError');
    },
    remove(context, index) {
      return new Promise((resolve) => {
        if (context.state.form[index].type === 'ticket') {
          analytics.removeTicketFromCart(context.state.form[index]);
        } else if (context.state.form[index].type === 'guidedTour') {
          analytics.removeGuidedTourFromCart(context.state.form[index]);
        } else if (context.state.form[index].type === 'merchandise') {
          analytics.removeMerchandiseFromCart(context.state.form[index]);
        } else if (context.state.form[index].type === 'annualPass') {
          analytics.removeAnnualPassFromCart(context.state.form[index]);
        } else if (context.state.form[index].type === 'voucher') {
          analytics.removeVoucherFromCart(context.state.form[index]);
        }

        context.commit('remove', index);
        resolve();
      });
    },
    setError(context, error) {
      context.commit('setError', error);
    },
    setCartId(context, cartId) {
      return new Promise((resolve) => {
        context.commit('setCartId', cartId);
        resolve();
      });
    },
    setRequestInvoice(context, v) {
      context.commit('setRequestInvoice', v);
    },
    setDocumentNumber(context, v) {
      context.commit('setDocumentNumber', v);
    },
    calculateShipping(context) {
      return new Promise((resolve) => {
        context.commit('clearShippingError');
        const { app } = context.rootState;
        let shouldCalculate = false;
        context.state.form.find((item) => {
          if (item.type === 'merchandise') {
            shouldCalculate = true;
            return true;
          }
          return false;
        });
        let canCalculateShipping = false;
        let data = {};
        let url = '';
        if (typeof context.rootState.user.data.jwt !== 'undefined') {
          if (context.rootState.user.data.jwt !== '') {
            canCalculateShipping = true;
            url = `${app.API_URL}${context.rootState.language}/${app.endpoints.SHIPPING_COSTS}?_=${context.rootState.user.data.jwt}`;
            data = {
              cart: prepareCart(context.state.form),
            };
          }
        }
        if (
          !canCalculateShipping &&
          context.rootState.user.form.country.key &&
          context.rootState.user.form.country.key !== ''
        ) {
          canCalculateShipping = true;
          url = `${app.API_URL}${context.rootState.language}/${app.endpoints.SHIPPING_COSTS}`;
          data = {
            country: context.rootState.user.form.country.key,
            cart: prepareCart(context.state.form),
          };
        } else if (!canCalculateShipping && typeof window.sessionStorage.customer !== 'undefined') {
          canCalculateShipping = true;
          url = `${app.API_URL}${context.rootState.language}/${app.endpoints.SHIPPING_COSTS}`;
          const costumer = JSON.parse(window.sessionStorage.customer);
          const { country } = costumer;
          if (country === '') {
            canCalculateShipping = false;
          }
          data = {
            country,
            cart: prepareCart(context.state.form),
          };
        }
        const type = 'POST';
        if (!(shouldCalculate && canCalculateShipping)) {
          context.commit('setShippingCost', null);
        } else {
          request.make(
            {
              url,
              data,
              type,
            },
            (err, res) => {
              if (err === null) {
                context.commit('setShippingCost', res.body.data);
                resolve();
              } else {
                context.commit('setShippingCost', null);
                context.commit('setShippingCostError', res.body);
                resolve();
              }
            }
          );
        }
        if (!canCalculateShipping) {
          context.commit('setShippingCost', null);
        }
      });
    },
    calculateVoucherValues(context) {
      context.commit('calculateVoucherValues');
    },

    recalculatePromoCodes(context) {
      //get current PromoCodes
      const promoCodes = [];
      context.state.form.forEach((item) => {
        if (item.type === 'promoCode') {
          promoCodes.push(item.keyword);
        }
      });
      // Also check for item-level promo codes stored in promoCodes module
      if (promoCodes.length === 0 && context.rootState.promoCodes.form.code) {
        promoCodes.push(context.rootState.promoCodes.form.code);
      }
      //Delete all
      context.commit('removePromocode');
      //Revalidate
      for (let i = 0; i < promoCodes.length; i++) {
        context.dispatch('promoCodes/setCode', promoCodes[i], { root: true }).then(() => {
          context.dispatch('promoCodes/validate', null, { root: true });
        });
      }
    },
    removePromocode(context) {
      context.commit('removePromocode');
    },
    setPromoCodeDoesNotApplyToCurrentItems(context, v) {
      context.commit('setPromoCodeDoesNotApplyToCurrentItems', v);
    },
  },
  getters: {
    hasCustomerDiscount(state) {
      return state.form.some((item) => typeof item.customerDiscountOriginalPrice !== 'undefined');
    },
    totalWithoutDiscounts(state) {
      let total = 0;
      let sc = parseInt(state.shippingCosts, 10);
      if (Number.isNaN(sc)) {
        sc = 0;
      }
      state.form.forEach((item) => {
        if (item.type !== 'promoCode') {
          total += parseInt(item.totalPrice, 10);
        }
      });

      total += sc;
      if (total < 0) {
        total = 0;
      }
      return total;
    },
    total(state) {
      let total = 0;
      let sc = parseInt(state.shippingCosts, 10);
      if (Number.isNaN(sc)) {
        sc = 0;
      }
      state.form.forEach((item) => {
        if (item.type !== 'promoCode') {
          total += parseInt(item.totalPrice, 10);
        }
      });
      state.form.forEach((item) => {
        if (item.type === 'promoCode') {
          if (parseInt(item.units, 0) === 0) {
            let discount = total * (item.amount / 100);
            discount = Math.round(discount);
            total = total - discount;
          } else {
            total = Math.round(total - item.amount);
          }
        }
      });

      total += sc;
      if (total < 0) {
        total = 0;
      }
      return total;
    },
    totalWithoutVouchers(state) {
      return totalWithoutVouchersLocal(state);
    },
    thereIsAVoucher(state) {
      const v = state.form.find((i) => i.type === 'voucherCode');
      if (typeof v !== 'undefined') {
        return true;
      }
      return false;
    },
    thereIsMerch(state) {
      const v = state.form.find((i) => i.type === 'merchandise');
      if (typeof v !== 'undefined') {
        return true;
      }
      return false;
    },
    thereAreRealItemsInCart(state) {
      const v = state.form.find((i) => i.type !== 'voucherCode');
      if (typeof v !== 'undefined') {
        return true;
      }
      return false;
    },
    paypalCart(state, getters) {
      const total = (getters.total / 100).toFixed(2);
      const subTotal = (getters.total / 100).toFixed(2);
      const payment = {
        transactions: [
          {
            amount: {
              total,
              currency: 'EUR',
              details: {
                subtotal: subTotal,
                tax: '0',
                shipping: '0',
                handling_fee: '0',
                shipping_discount: '0',
                insurance: '0',
              },
            },
            item_list: { items: [] },
          },
        ],
      };

      payment.transactions[0].item_list = { items: [] };
      state.form.forEach((item) => {
        let quantity = 0;
        if (typeof item.totalCount !== 'undefined') {
          quantity = item.totalCount.toString();
        }
        if (item.type === 'merchandise') {
          quantity = item.count.toString();
        }
        payment.transactions[0].item_list.items.push({
          name: item.name,
          quantity,
          price: (item.totalPrice / 100).toFixed(2),
          tax: '0.00',
          currency: 'EUR',
        });
      });
      return payment;
    },
  },
};
